import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../network';
import { getSessionShop, useSession } from '../../../../infra/session';
export var useWaitingListSettings = function () {
    var session = useSession().data;
    var shop = getSessionShop(session);
    return useApiQuery({
        endpoint: endpoints.waitingListSettingsQuery,
        payload: {
            shopId: (shop === null || shop === void 0 ? void 0 : shop.id) || '',
        },
        options: {
            enabled: !!(shop === null || shop === void 0 ? void 0 : shop.id),
        },
    });
};
